/* Lower HQ: finds every brand in the live catalog and fills the homepage brand strip and [brands] text.
   Brand = a known brand name found in the product title, else the vendor (unless the vendor is a supplier).
   Results are cached in the visitor's browser for 6 hours. */
(function () {
  var cfgEl = document.getElementById('lhq-brand-config');
  if (!cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var targets = document.querySelectorAll('[data-lhq-brands], [data-lhq-brand-text]');
  if (!targets.length) return;
  var KEY = 'lhqBrands:' + cfg.v, TTL = 6 * 3600 * 1000;

  var norm = function (s) { return (s || '').toLowerCase().replace(/[\/,]/g, ' ').replace(/\s+/g, ' '); };
  var flat = function (s) { return (s || '').toLowerCase().replace(/[\s\-,]/g, ''); };
  var TAILS = { racing: 1, speed: 1, performance: 1, suspension: 1, industries: 1, american: 1 };
  var suppliers = {}; cfg.suppliers.forEach(function (s) { suppliers[s.trim().toLowerCase()] = 1; });
  var brands = cfg.brands.map(function (raw) {
    var parts = raw.split('='), n = parts[0].trim(), shown = (parts[1] || n).trim();
    var k = n.toLowerCase(), w = k.split(' ');
    return { name: shown, start: ' ' + k + ' ', any: k.length >= 5, first: (w.length === 2 && TAILS[w[1]]) ? ' ' + w[0] + ' ' : null, flat: flat(n) };
  });
  function brandOf(title, vendor) {
    var t = ' ' + norm(title) + ' ', v = flat(vendor);
    for (var i = 0; i < brands.length; i++) {
      var b = brands[i];
      if (t.indexOf(b.start) === 0 || (b.any && t.indexOf(b.start) > -1) || (b.first && t.indexOf(b.first) === 0) || (b.flat.length >= 3 && v.indexOf(b.flat) === 0)) return b.name;
    }
    return suppliers[(vendor || '').trim().toLowerCase()] ? null : vendor;
  }
  function render(list) {
    var byCount = list.slice().sort(function (a, b) { return b.n - a.n; });
    document.querySelectorAll('[data-lhq-brands]').forEach(function (el) {
      var max = +el.getAttribute('data-limit') || 36;
      el.innerHTML = byCount.slice(0, max).map(function (b) {
        return '<a class="lhq-brand" href="' + cfg.search + '?q=' + encodeURIComponent(b.name) + '&type=product&options%5Bprefix%5D=last">' + b.name.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }) + '</a>';
      }).join('');
    });
    document.querySelectorAll('[data-lhq-brand-text]').forEach(function (el) {
      var max = +el.getAttribute('data-limit') || 6, sep = el.getAttribute('data-sep') || ', ';
      var names = list.slice(0, max).map(function (b) { return b.name; });
      el.textContent = names.join(sep) + (list.length > max && !el.hasAttribute('data-no-more') ? ' and more' : '');
    });
  }
  try {
    var c = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (c && Date.now() - c.t < TTL && c.list && c.list.length) { render(c.list); return; }
  } catch (e) {}

  var url = function (p) { return cfg.feed + (cfg.feed.indexOf('?') > -1 ? '&' : '?') + 'view=lhq-brands&page=' + p; };
  var counts = {};
  function add(items) {
    items.forEach(function (it) {
      var b = brandOf(it[0], it[1]); if (!b) return;
      var r = counts[b] || (counts[b] = { name: b, n: 0, inStock: 0 }); r.n++; if (it[2]) r.inStock++;
    });
  }
  fetch(url(1), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (first) {
    add(first.items);
    var jobs = [];
    for (var p = 2; p <= Math.min(first.pages, 40); p++) jobs.push(fetch(url(p), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) { add(d.items); }).catch(function () {}));
    return Promise.all(jobs);
  }).then(function () {
    var list = Object.keys(counts).map(function (k) { return counts[k]; })
      .filter(function (b) { return b.n >= (cfg.min || 1); })
      .sort(function (a, b) { return (b.inStock > 0) - (a.inStock > 0) || b.n - a.n; });
    if (!list.length) return;
    try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), list: list })); } catch (e) {}
    render(list);
  }).catch(function () {});
})();
